module.exports = "<!-- <app-nav-bar></app-nav-bar> -->\n<!-- <div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div> -->\n\n<router-outlet></router-outlet>\n<!--  <app-login-layout></app-login-layout>\n <app-home-layout></app-home-layout> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 490
// module chunks = 1